module.exports = __webpack_public_path__ + "img/apollologo.4baac096.png";